/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Reducer for the container.
 */
import { updateState } from '../../common/helpers';
import { NOTIFY, FETCH_COMPLETE, FETCH_DATA } from './types';

const INITIAL_STATE = {
    formOpen: false,
    customsHouses: [],
    showNotification:false,
    showMessage: '',
    notificationColor: ''
};

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case NOTIFY:
            return updateState(payload, state);
        case FETCH_DATA:
            return { ...state, isLoading: true };
        case FETCH_COMPLETE:
            return { ...state, ...updateState(payload, state), isLoading: false };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./containers/aduanas/reducer.js